import React from "react";
import "./Prize.css";

const Prize = () => {
    return <>

        {/*   <div className="hack4bengal__section9-body">
            <div className="hack4bengal__section9-description">

                <div className="prizes_box_main">
                    <div className="prizebox prizebox1">
                        <div className="prizebox_imgdiv prizebox1_imgdiv">
                            <img
                                src="https://hackthisfall.tech/_nuxt/img/silver.3e9bbcb.svg"
                                alt=""
                            />
                        </div>

                        <div className="prizes_textdiv prizes_textdiv1">
                            <div className="prize_textdiv_texts">
                                <h1>₹20k</h1>
                                <h2>1st Runner-Up</h2>
                            </div>
                        </div>
                    </div>
                    <div className="prizebox prizebox2">
                        <div className="prizebox_imgdiv prizebox1_imgdiv">
                            <img
                                src="https://hackthisfall.tech/_nuxt/img/gold.e3b24e8.svg"
                                alt=""
                            />
                        </div>

                        <div className="prizes_textdiv prizes_textdiv2">
                            <div className="prize_textdiv_texts">
                                <h1>₹30k</h1>
                                <h2>Winner</h2>
                            </div>
                        </div>
                    </div>
                    <div className="prizebox prizebox1">
                        <div className="prizebox_imgdiv prizebox1_imgdiv">
                            <img
                                src="https://hackthisfall.tech/_nuxt/img/bronze.eb1941a.svg"
                                alt=""
                            />
                        </div>

                        <div className="prizes_textdiv prizes_textdiv3">
                            <div className="prize_textdiv_texts">
                                <h1>₹20k</h1>
                                <h2>2nd Runner-Up</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div> */}

        <div className="hack4bengal__section9-title sponsored_prizes_titlediv">
            <div className="hack4bengal__section9-title1">Sponsored Prizes</div>
            <hr />

        </div>

        <div className="prize_main_div">
            <div className="prize_box">
                <img src="https://hackthisfall.tech/_nuxt/img/azure-horiz.4f55fb3.png" alt="" />

                <div className="prize_box_text">
                    <h1>Best use of Microsoft Cloud for your community</h1>
                    <h2>LinkedIN premium, 12 months subscription and XBox ultimate 3-month Game pass</h2>
                </div>

            </div>
            <div className="prize_box">
                <img src="https://hackthisfall.tech/_nuxt/img/peerlist.15b7689.png" alt="" />

                <div className="prize_box_text">
                    <h1>Top-3 Projects uploaded on Peerlist</h1>
                    <h2>Each winning team member recieves a special peerlist swag package. </h2>
                </div>

            </div>
            <div className="prize_box">
                <img src="https://hackthisfall.tech/_nuxt/img/peerlist.15b7689.png" alt="" />

                <div className="prize_box_text">
                    <h1>Top-3 Projects uploaded on Peerlist</h1>
                    <h2>Each winning team member recieves a special peerlist swag package. </h2>
                </div>

            </div>
            <div className="prize_box">
                <img src="https://hackthisfall.tech/_nuxt/img/peerlist.15b7689.png" alt="" />

                <div className="prize_box_text">
                    <h1>Top-3 Projects uploaded on Peerlist</h1>
                    <h2>Each winning team member recieves a special peerlist swag package. </h2>
                </div>

            </div>
            <div className="prize_box">
                <img src="https://hackthisfall.tech/_nuxt/img/peerlist.15b7689.png" alt="" />

                <div className="prize_box_text">
                    <h1>Top-3 Projects uploaded on Peerlist</h1>
                    <h2>Each winning team member recieves a special peerlist swag package. </h2>
                </div>

            </div>


            <div className="prize_box">
                <img src="https://hackthisfall.tech/_nuxt/img/peerlist.15b7689.png" alt="" />

                <div className="prize_box_text">
                    <h1>Top-3 Projects uploaded on Peerlist</h1>
                    <h2>Each winning team member recieves a special peerlist swag package. </h2>
                </div>

            </div>
        </div>


    </>;
};

export default Prize;
